import React from "react";
import PropTypes from "prop-types";

import { isEmbeddedElement } from "utils/pageElements/helpers";
import Typography from "@mui/material/Typography";

const truncateText = (text, length = 40) => {
  const stripped = text.replace(/<[^>]*>/g, "");
  return `"${stripped.substring(0, length)}${stripped.length > length ? "..." : ""}"`;
};

const Description = ({ type, content, settings, link_title }) => {

  const isEmbedded = isEmbeddedElement(type);
  
  const contentRenderers = {
    text: () => truncateText(content || ""),
    title: () => `"${content}"`,
    embed: () => content,
    link: () => (link_title ? truncateText(link_title) : content),
    calendar: () => `Showing the next ${settings?.number_of_events || 3} events`,
  };

  return (
    <Typography variant="caption" sx={{ color: "text.secondary", wordBreak: "break-word" }}>
      {contentRenderers[isEmbedded ? "embed" : type]?.()}
    </Typography>
  );
};

Description.propTypes = {
  type: PropTypes.string.isRequired,
  content: PropTypes.string,
  settings: PropTypes.object,
  link_title: PropTypes.string,
};

export default Description;
